import { render, staticRenderFns } from "./ResultRow.vue?vue&type=template&id=10da6222&scoped=true"
import script from "./ResultRow.vue?vue&type=script&lang=js"
export * from "./ResultRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10da6222",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10da6222')) {
      api.createRecord('10da6222', component.options)
    } else {
      api.reload('10da6222', component.options)
    }
    module.hot.accept("./ResultRow.vue?vue&type=template&id=10da6222&scoped=true", function () {
      api.rerender('10da6222', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/infra/questionConfig/components/ResultRow.vue"
export default component.exports